"use strict";

/** global strings used in templates */
module.exports = {
    fr: {
        month_1: "janvier",
        month_2: "février",
        month_3: "mars",
        month_4: "avril",
        month_5: "mai",
        month_6: "juin",
        month_7: "juillet",
        month_8: "août",
        month_9: "septembre",
        month_10: "octobre",
        month_11: "novembre",
        month_12: "décembre",
        day_0: "dimanche",
        day_1: "lundi",
        day_2: "mardi",
        day_3: "mercredi",
        day_4: "jeudi",
        day_5: "vendredi",
        day_6: "samedi",

        theme_arts: "arts",
        theme_catastrophes: "catastrophes",
        theme_colonies: "colonies",
        theme_conflits_et_relations_internationales: "conflits et relations internationales",
        theme_economie: "économie",
        theme_education: "éducation",
        theme_justice: "justice",
        theme_medias: "médias",
        theme_politique: "politique",
        theme_religions: "religions",
        theme_sante: "santé",
        theme_sciences: "sciences",
        theme_societe: "société",
        theme_sports_et_loisirs: "sports et loisirs",

        theme_l2_architecture: "Architecture",
        theme_l2_arts_decoratifs: "Arts décoratifs",
        theme_l2_musee: "Musée",
        theme_l2_bibliotheque: "Bibliothèque",
        theme_l2_cabinet_des_estampes: "Cabinet des estampes",
        theme_l2_cinema: "Cinéma",
        theme_l2_collection_doeuvres_dart: "Collection d'œuvres d'art",
        theme_l2_cabinet_de_curiosites: "Cabinet de curiosités",
        theme_l2_coutumes_et_traditions: "Coutumes et traditions",
        theme_l2_culture_religieuse: "Culture religieuse",
        theme_l2_culture_militaire: "Culture militaire",
        theme_l2_culture_populaire: "Culture populaire",
        theme_l2_danse: "Danse",
        theme_l2_exposition_dart: "Exposition d'art",
        theme_l2_foire: "Foire",
        theme_l2_exposition_universelle: "Exposition universelle",
        theme_l2_gastronomie: "Gastronomie",
        theme_l2_litterature: "Littérature",
        theme_l2_marche_de_lart: "Marché de l'art",
        theme_l2_mode: "Mode",
        theme_l2_musique: "Musique",
        theme_l2_patrimoine_naturel: "Patrimoine naturel",
        theme_l2_patrimoine_artistique: "Patrimoine artistique",
        theme_l2_patrimoine_architectural: "Patrimoine architectural",
        theme_l2_peinture: "Peinture",
        theme_l2_photographie: "Photographie",
        theme_l2_radio: "Radio",
        theme_l2_sculpture: "Sculpture",
        theme_l2_theatre: "Théâtre",
        theme_l2_urbanisme: "Urbanisme",
        theme_l2_dessin_anime: "Dessin animé",
        theme_l2_bande_dessinee: "Bande dessinée",
        theme_l2_opera: "Opéra",
        theme_l2_television: "Télévision",
        theme_l2_parfumerie: "Parfumerie",
        theme_l2_accident_aerien: "Accident aérien",
        theme_l2_accident_maritime: "Accident maritime",
        theme_l2_accident_ferroviaire: "Accident ferroviaire",
        theme_l2_accident_routier: "Accident routier",
        theme_l2_accident_industriel: "Accident industriel",
        theme_l2_desastre_meteorologique: "Désastre météorologique",
        theme_l2_epizooties: "Épizooties",
        theme_l2_eruption_volcanique: "Éruption volcanique",
        theme_l2_famine: "Famine",
        theme_l2_incendie: "Incendie",
        theme_l2_inondation: "Inondation",
        theme_l2_pollution: "Pollution",
        theme_l2_secheresse: "Sécheresse",
        theme_l2_tremblement_de_terre: "Tremblement de terre",
        theme_l2_maree_noire: "Marée noire",
        theme_l2_catastrophe_miniere: "Catastrophe minière",
        theme_l2_rupture_de_barrage: "Rupture de barrage",
        theme_l2_explosion_accidentelle: "Explosion accidentelle",
        theme_l2_administration_coloniale: "Administration coloniale",
        theme_l2_colons: "Colons",
        theme_l2_compagnies_coloniales: "Compagnies coloniales",
        theme_l2_conquetes: "Conquêtes",
        theme_l2_economie_coloniale: "Économie coloniale",
        theme_l2_exposition_coloniale: "Exposition coloniale",
        theme_l2_peuples_colonises: "Peuples colonisés",
        theme_l2_presse_coloniale: "Presse coloniale",
        theme_l2_propagande_coloniale: "Propagande coloniale",
        theme_l2_rivalites_coloniales: "Rivalités coloniales",
        theme_l2_expedition_coloniale: "Expédition coloniale",
        theme_l2_armement: "Armement",
        theme_l2_conferences_et_sommets: "Conférences et sommets",
        theme_l2_coup_detat: "Coup d'État",
        theme_l2_economie_de_guerre: "Économie de guerre",
        theme_l2_guerre: "Guerre",
        theme_l2_massacre: "Massacre",
        theme_l2_traites_et_accords: "Traités et accords",
        theme_l2_agriculture: "Agriculture",
        theme_l2_elevage: "Élevage",
        theme_l2_viticulture: "Viticulture",
        theme_l2_finances_publiques: "Finances publiques",
        theme_l2_analyse_financiere: "Analyse financière",
        theme_l2_industrie_chimique: "Industrie chimique",
        theme_l2_commerce: "Commerce",
        theme_l2_distribution: "Distribution",
        theme_l2_energie_nucleaire: "Énergie nucléaire",
        theme_l2_electricite: "Électricité",
        theme_l2_petrole: "Pétrole",
        theme_l2_mineraux: "Minéraux",
        theme_l2_charbon: "Charbon",
        theme_l2_gaz_naturel: "Gaz naturel",
        theme_l2_immobilier: "Immobilier",
        theme_l2_industrie_de_transformation: "Industrie de transformation",
        theme_l2_industries_metallurgiques_et_mecaniques: "Industries métallurgiques et mécaniques",
        theme_l2_macro_economie: "Macro économie",
        theme_l2_marches: "Marchés",
        theme_l2_metaux: "Métaux",
        theme_l2_services_financiers: "Services financiers",
        theme_l2_transport: "Transport",
        theme_l2_vie_des_affaires: "Vie des affaires",
        theme_l2_concours: "Concours",
        theme_l2_etablissement_denseignement_superieur: "Établissement d'enseignement supérieur",
        theme_l2_ecole_secondaire: "École secondaire",
        theme_l2_ecole_professionnelle: "École professionnelle",
        theme_l2_ecole_primaire: "École primaire",
        theme_l2_maternelle: "Maternelle",
        theme_l2_education_des_filles: "Éducation des filles",
        theme_l2_education_religieuse: "Éducation religieuse",
        theme_l2_enseignants: "Enseignants",
        theme_l2_lois_scolaires: "Lois scolaires",
        theme_l2_pedagogie: "Pédagogie",
        theme_l2_universite: "Université",
        theme_l2_parc_naturel: "Parc naturel",
        theme_l2_dechets: "Déchets",
        theme_l2_reserve_naturelle: "Réserve naturelle",
        theme_l2_ecosysteme: "Écosystème",
        theme_l2_espece_menacee: "Espèce menacée",
        theme_l2_meteo: "Météo",
        theme_l2_attentat: "Attentat",
        theme_l2_crime_de_guerre: "Crime de guerre",
        theme_l2_assassinat: "Assassinat",
        theme_l2_evasion: "Évasion",
        theme_l2_piraterie: "Piraterie",
        theme_l2_infraction_sexuelle: "Infraction sexuelle",
        theme_l2_braquage: "Braquage",
        theme_l2_faux_en_art: "Faux en art",
        theme_l2_contrebande: "Contrebande",
        theme_l2_incendie_volontaire: "Incendie volontaire",
        theme_l2_agression: "Agression",
        theme_l2_enlevement: "Enlèvement",
        theme_l2_crime_organise: "Crime organisé",
        theme_l2_terrorisme: "Terrorisme",
        theme_l2_vol: "Vol",
        theme_l2_detournement_davion: "Détournement d'avion",
        theme_l2_prise_dotages: "Prise d'otages",
        theme_l2_faux_monnayage: "Faux-monnayage",
        theme_l2_corruption: "Corruption",
        theme_l2_fraude_fiscale: "Fraude fiscale",
        theme_l2_droits: "Droits",
        theme_l2_lois: "Lois",
        theme_l2_prison: "Prison",
        theme_l2_condamnation_a_perpetuite: "Condamnation à perpétuité",
        theme_l2_torture_et_punition_corporelle: "Torture et punition corporelle",
        theme_l2_police: "Police",
        theme_l2_etablissement_penitentiaire: "Établissement pénitentiaire",
        theme_l2_proces: "Procès",
        theme_l2_scandale: "Scandale",
        theme_l2_systeme_judiciaire: "Système judiciaire",
        theme_l2_journalistes_et_reporters: "Journalistes et reporters",
        theme_l2_liberte_de_la_presse_et_censure: "Liberté de la presse et censure",
        theme_l2_patrons_de_presse: "Patrons de presse",
        theme_l2_presse_ecrite: "Presse écrite",
        theme_l2_propagande: "Propagande",
        theme_l2_agence_de_presse: "Agence de presse",
        theme_l2_aide_internationale: "Aide internationale",
        theme_l2_dette_publique: "Dette publique",
        theme_l2_fiscalite: "Fiscalité",
        theme_l2_impot_religieux: "Impôt religieux",
        theme_l2_communisme: "Communisme",
        theme_l2_constitution: "Constitution",
        theme_l2_renseignement_militaire: "Renseignement militaire",
        theme_l2_armee: "Armée",
        theme_l2_mercenariat: "Mercenariat",
        theme_l2_diplomatie: "Diplomatie",
        theme_l2_droits_de_lhomme: "Droits de l'homme",
        theme_l2_elections: "Élections",
        theme_l2_espionnage: "Espionnage",
        theme_l2_gouvernement: "Gouvernement",
        theme_l2_groupe_de_pression: "Groupe de pression",
        theme_l2_ideologies_et_systemes: "Idéologies et systèmes",
        theme_l2_institutions_locales: "Institutions locales",
        theme_l2_migration: "Migration",
        theme_l2_parlement: "Parlement",
        theme_l2_partis_politiques: "Partis politiques",
        theme_l2_politique_sociale_en_france: "Politique sociale en France",
        theme_l2_politique_culturelle_en_france: "Politique culturelle en France",
        theme_l2_politique_des_transports_en_france: "Politique des transports en France",
        theme_l2_politique_energetique_en_france: "Politique énergétique en France",
        theme_l2_amenagement_du_territoire_en_france: "Aménagement du territoire en France",
        theme_l2_referendum: "Référendum",
        theme_l2_socialisme: "Socialisme",
        theme_l2_organisation_internationale: "Organisation internationale",
        theme_l2_nationalisation: "Nationalisation",
        theme_l2_privatisation: "Privatisation",
        theme_l2_chefs_religieux: "Chefs religieux",
        theme_l2_eglise_institution: "Église - Institution",
        theme_l2_evenement_religieux: "Événement religieux",
        theme_l2_ordres_religieux: "Ordres religieux",
        theme_l2_relations_entre_institutions_religieuses_et_letat: "Relations entre Institutions religieuses et l'État",
        theme_l2_rite: "Rite",
        theme_l2_texte_religieux: "Texte religieux",
        theme_l2_epidemie: "Épidémie",
        theme_l2_examens_medicaux: "Examens médicaux",
        theme_l2_hopitaux_et_cliniques: "Hôpitaux et cliniques",
        theme_l2_hygiene: "Hygiène",
        theme_l2_maladies: "Maladies",
        theme_l2_medicament: "Médicament",
        theme_l2_organisation_de_sante: "Organisation de santé",
        theme_l2_personnel_medical: "Personnel médical",
        theme_l2_politique_de_sante: "Politique de santé",
        theme_l2_traitement_medical: "Traitement médical",
        theme_l2_chirurgie: "Chirurgie",
        theme_l2_vaccin: "Vaccin",
        theme_l2_climatologie: "Climatologie",
        theme_l2_ethnologie: "Ethnologie",
        theme_l2_geographie: "Géographie",
        theme_l2_geologie: "Géologie",
        theme_l2_histoire: "Histoire",
        theme_l2_institutions_scientifiques: "Institutions scientifiques",
        theme_l2_mathematiques: "Mathématiques",
        theme_l2_oceanographie: "Océanographie",
        theme_l2_philosophie_des_sciences: "Philosophie des sciences",
        theme_l2_prix_et_recompenses: "Prix et récompenses",
        theme_l2_societe_savante: "Société savante",
        theme_l2_laboratoire_de_recherche: "Laboratoire de recherche",
        theme_l2_recherche_medicale: "Recherche médicale",
        theme_l2_archeologie: "Archéologie",
        theme_l2_sylviculture: "Sylviculture",
        theme_l2_artisanat: "Artisanat",
        theme_l2_technique_policiere: "Technique policière",
        theme_l2_metallurgie: "Métallurgie",
        theme_l2_pharmacie: "Pharmacie",
        theme_l2_aeronautique: "Aéronautique",
        theme_l2_optique: "Optique",
        theme_l2_astronautique: "Astronautique",
        theme_l2_astronomie: "Astronomie",
        theme_l2_construction: "Construction",
        theme_l2_metrologie: "Métrologie",
        theme_l2_armurerie: "Armurerie",
        theme_l2_medecine: "Médecine",
        theme_l2_technologie_miniere: "Technologie minière",
        theme_l2_technologie_du_transport: "Technologie du transport",
        theme_l2_genie_civil: "Génie civil",
        theme_l2_genie_chimique: "Génie chimique",
        theme_l2_genie_mecanique: "Génie mécanique",
        theme_l2_hydraulique: "Hydraulique",
        theme_l2_agronomie: "Agronomie",
        theme_l2_electronique: "Électronique",
        theme_l2_zoologie: "Zoologie",
        theme_l2_botanique: "Botanique",
        theme_l2_paleontologie: "Paléontologie",
        theme_l2_chimie: "Chimie",
        theme_l2_horticulture: "Horticulture",
        theme_l2_physique: "Physique",
        theme_l2_exploration_scientifique: "Exploration scientifique",
        theme_l2_anthropologie: "Anthropologie",
        theme_l2_linguistique: "Linguistique",
        theme_l2_sociologie: "Sociologie",
        theme_l2_activites_caritatives: "Activités caritatives",
        theme_l2_noblesse: "Noblesse",
        theme_l2_proletariat: "Prolétariat",
        theme_l2_domesticite: "Domesticité",
        theme_l2_bourgeoisie_urbaine: "Bourgeoisie urbaine",
        theme_l2_categories_sociales_et_professionnelles: "Catégories sociales et professionnelles",
        theme_l2_chomage: "Chômage",
        theme_l2_condition_feminine: "Condition féminine",
        theme_l2_duree_du_travail: "Durée du travail",
        theme_l2_syndicalisme: "Syndicalisme",
        theme_l2_travail_des_enfants: "Travail des enfants",
        theme_l2_demographie: "Démographie",
        theme_l2_esclavage: "Esclavage",
        theme_l2_homosexualite: "Homosexualité",
        theme_l2_mariage: "Mariage",
        theme_l2_divorce: "Divorce",
        theme_l2_avortement: "Avortement",
        theme_l2_greve: "Grève",
        theme_l2_lois_sur_le_travail: "Lois sur le travail",
        theme_l2_orphelinat: "Orphelinat",
        theme_l2_pauvrete: "Pauvreté",
        theme_l2_protection_sociale: "Protection sociale",
        theme_l2_racisme_et_xenophobie: "Racisme et Xénophobie",
        theme_l2_salaires: "Salaires",
        theme_l2_delinquance_juvenile: "Délinquance juvénile",
        theme_l2_prostitution: "Prostitution",
        theme_l2_suicide: "Suicide",
        theme_l2_pornographie: "Pornographie",
        theme_l2_troubles_civils: "Troubles civils",
        theme_l2_alpinisme_et_escalade: "Alpinisme et escalade",
        theme_l2_athletisme: "Athlétisme",
        theme_l2_automobile: "Automobile",
        theme_l2_aviron: "Aviron",
        theme_l2_badminton: "Badminton",
        theme_l2_boule_anglaise_et_petanque: "Boule anglaise et pétanque",
        theme_l2_bowling: "Bowling",
        theme_l2_boxe: "Boxe",
        theme_l2_carnavals_et_corteges: "Carnavals et cortèges",
        theme_l2_chasse: "Chasse",
        theme_l2_clubs_et_associations: "Clubs et associations",
        theme_l2_course_de_chiens: "Course de chiens",
        theme_l2_cricket: "Cricket",
        theme_l2_curling: "Curling",
        theme_l2_cyclisme: "Cyclisme",
        theme_l2_equitation: "Équitation",
        theme_l2_escrime: "Escrime",
        theme_l2_evenements_sportifs: "Événements sportifs",
        theme_l2_football: "Football",
        theme_l2_golf: "Golf",
        theme_l2_gymnastique_artistique: "Gymnastique artistique",
        theme_l2_halterophilie: "Haltérophilie",
        theme_l2_hippisme: "Hippisme",
        theme_l2_hockey_sur_gazon: "Hockey sur gazon",
        theme_l2_jeux_de_societe: "Jeux de société",
        theme_l2_echecs: "Échecs",
        theme_l2_jeux_de_cartes: "Jeux de cartes",
        theme_l2_jeux_de_hasard_et_loteries: "Jeux de hasard et loteries",
        theme_l2_jeux_olympiques: "Jeux olympiques",
        theme_l2_judo: "Judo",
        theme_l2_karate: "Karaté",
        theme_l2_lacrosse: "Lacrosse",
        theme_l2_luge: "Luge",
        theme_l2_lutte: "Lutte",
        theme_l2_natation: "Natation",
        theme_l2_patinage_artistique: "Patinage artistique",
        theme_l2_patinage_de_vitesse: "Patinage de vitesse",
        theme_l2_peche: "Pêche",
        theme_l2_pelote_basque: "Pelote basque",
        theme_l2_polo: "Polo",
        theme_l2_rodeo: "Rodéo",
        theme_l2_rugby_a_xv: "Rugby à XV",
        theme_l2_ski: "Ski",
        theme_l2_sports_aeriens_et_daviation: "Sports aériens et d'aviation",
        theme_l2_tennis: "Tennis",
        theme_l2_tennis_de_table: "Tennis de table",
        theme_l2_tir: "Tir",
        theme_l2_tir_a_larc: "Tir à l'arc",
        theme_l2_tourisme: "Tourisme",
        theme_l2_voile: "Voile",
        theme_l2_basket_ball: "Basket-ball",
        theme_l2_tauromachie: "Tauromachie",
        theme_l2_handball: "Handball",
        theme_l2_hockey_sur_glace: "Hockey sur glace",
        theme_l2_marathon: "Marathon",
        theme_l2_moto: "Moto",
        theme_l2_sumo: "Sumo",
        theme_l2_volley_ball: "Volley-ball",
        theme_l2_water_polo: "Water-polo",
        theme_l2_catch: "Catch",

        theme_l2_bibliotheque_et_musee: "Bibliothèque et musée",
        theme_l2_arts_radio: "Radio",
        theme_l2_patrimoine: "Patrimoine",
        theme_l2_divertissement: "Divertissement",
        theme_l2_culture: "Culture",
        theme_l2_expositions_et_salons: "Expositions et salons",
        theme_l2_collections: "Collections",
        theme_l2_marches_de_l_art: "Marché de l'art",
        theme_l2_expositions_universelles: "Expositions universelles",
        theme_l2_criminalite: "Criminalité",
        theme_l2_peines: "Peines",
        theme_l2_accusation: "Accusation",
        theme_l2_delinquance_financiere: "Délinquance financière",
        theme_l2_crimes_de_guerre: "Crime de guerre",
        theme_l2_attentats: "Attentat",
        theme_l2_scandales: "Scandale",
        theme_l2_faits_divers: "Fait divers",
        theme_l2_accidents_industriels: "Accident industriel",
        theme_l2_desastres_meteorologiques: "Désastre météorologique",
        theme_l2_accident_de_transport: "Accident de transport",
        theme_l2_equipement_et_immobilier: "Equipement et immobilier",
        theme_l2_energie_et_ressources: "Energie et ressources",
        theme_l2_metaux_et_mineraux: "Métaux et minéraux",
        theme_l2_industries_de_transformation: "Industries de transformation",
        theme_l2_commerce_international: "Commerce",
        theme_l2_banques_et_finances: "Banques et Finances",
        theme_l2_enfance: "Enfance",
        theme_l2_ecole: "Ecoles",
        theme_l2_epidemies: "Epidémies",
        theme_l2_traitements: "Traitements",
        theme_l2_organisations_de_sante: "Organisations de santé",
        theme_l2_medicaments: "Médicaments",
        theme_l2_blessures: "Blessures",
        theme_l2_specialisation_medicale: "Spécialisations médicales",
        theme_l2_defense: "Défense",
        theme_l2_droits_de_l_homme: "Droits de l'homme",
        theme_l2_budget_de_l_etat_et_impots: "Budget de l'Etat et impôts",
        theme_l2_traites_et_organisations_internationales: "Traités et organisations internationales",
        theme_l2_politique_interieure: "Politique Intérieure",
        theme_l2_migrations: "Migrations",
        theme_l2_medias_radio: "Radio",
        theme_l2_croyance: "Croyances (cultes et sectes > Christianisme, Judaïsme)",
        theme_l2_eglise: "Eglise",
        theme_l2_relations_entre_institutions_religieuses_et_l_etat: "Relations entre Institutions religieuses et l'Etat (Concordat)",
        theme_l2_textes_religieux: "Textes religieux",
        theme_l2_evenements_religieux: "Evénement religieux",
        theme_l2_sciences_et_religions: "Sciences et religions",
        theme_l2_rites: "Rites",
        theme_l2_sciences_appliquees: "Sciences appliquées",
        theme_l2_recherche: "Recherche",
        theme_l2_technologie_et_ingenierie: "Technologie et Ingénierie",
        theme_l2_instituts_scientifiques: "Institutions scientifiques",
        theme_l2_activites_caricatives: "Activités caritatives",
        theme_l2_famille: "Famille",
        theme_l2_problemes_de_societe: "Problèmes de société",
        theme_l2_greves: "Grève",
        theme_l2_conditions_feminines: "Condition féminine",
        theme_l2_syndicats: "Syndicats",
        theme_l2_orphelinats: "Orphelinats",
        theme_l2_ascension_sociale_carriere: "Carrière/Ascension sociale",
        theme_l2_conditions_de_travail: "Conditions de travail",
        theme_l2_sports_aeriens_et_d_aviation: "Sports aériens et d'aviation",
        theme_l2_tir_a_l_arc: "Tir à l'arc",
        theme_l2_ski_acrobatique: "Ski acrobatique",
        theme_l2_rugby: "Rugby à XV",
        theme_l2_organisations_sportives: "Organisations sportives",
        theme_l2_desordres_civils: "Désordres civils",
        theme_l2_coup_d_etat: "Coup d'état",
        theme_l2_traites_et_accords_de_guerre: "Traités et acccords",
        theme_l2_sommets_et_conferences: "Conférences et sommets",
        theme_l2_enjeux_territoriaux: "Enjeux territoriaux",
        theme_l2_expositions_coloniales: "Expositions coloniales",
        theme_l2_colonialisme: "Colonialisme",       

        document_not_found: "document non trouvé",
        save_in_progress: "Sauvegarde en cours",
        unable_to_save: "Impossible de sauver pour le moment",
        save_ok: "Sauvegarde réussie",
        wrong_syntax_pages: "Veuillez vérifier la syntaxe des pages sélectionnées",
        something_wrong: "something goes wrong...",
        no_result: "Pas de résultat pour cette recherche",
        search_in_progress: "Recherche en cours...",
        facebook_message: "Explorer, trouver, comprendre",
        confirm_delete_annotation: "Etes-vous sûr de vouloir supprimer cette annotation?",
        text_is_missing: "Les fonctions texte, entités et recherche ne sont pas disponibles pour ce document",
        copy_url_ok: "L'URL pour accéder directement à cette page avec la zone surligée dans le lecteur est dans votre presse-papier.<br><br>Vous pouvez la coller avec CTRL+V",
        search_results: "résultats de recherche",
        no_other_result: "Pas d'autre résultat pour cette recherche",
        time_ago: {
            prefix: "Il y a ",
            suffix: "",
            seconds: "moins d'une minute",
            minute: "environ une minute",
            minutes: "%d minutes",
            hour: "environ une heure",
            hours: "environ %d heures",
            day: "un jour",
            days: "%d jours",
            month: "environ un mois",
            months: "%d mois",
            year: "un an",
            years: "%d ans"
        },
        comment_mini: "Veuillez saisir au minimum 20 caractères",
        no_main_articles: "Aucun article n'a été détecté dans cette page.",
        embed_activated:"Lecteur activé, vous pouvez vous déplacer",
        date: function(date,day_name) {
            if (!date) return;
            var date_array = date.split("-"),
                date_fr;
            if (date_array.length == 3) {
                date_fr = parseInt(date_array[2]) + " " + STR["month_" + parseInt(date_array[1])] + " " + date_array[0];
                if(day_name){
                    var date_obj=new Date(Date.UTC(parseInt(date_array[0]),parseInt(date_array[1])-1,parseInt(date_array[2])));
                    date_fr=STR["day_" +date_obj.getUTCDay()]+" "+date_fr;
                }
            }
            return date_fr;
        },
        number: function(n) {
            if (!n) return;
            return Number(n).toLocaleString(STR.locale, {
                useGrouping: true
            });
        },
        documentTitle:function(doc_title){
            if(!doc_title)return;
            var reg = new RegExp("^[0-9]+$");
            if (reg.test(doc_title)) {
                doc_title = "N°" + doc_title;
            }
            return doc_title;
        }
    },
    en: {
        month_1: "january",
        month_2: "february",
        month_3: "march",
        month_4: "april",
        month_5: "may",
        month_6: "june",
        month_7: "july",
        month_8: "august",
        month_9: "september",
        month_10: "october",
        month_11: "november",
        month_12: "december",
        day_0: "Sunday",
        day_1: "Monday",
        day_2: "Tuesday",
        day_3: "Wednesday",
        day_4: "Thursday",
        day_5: "Saturday",
        day_6: "samedi",
        theme_arts: "arts",
        theme_catastrophes: "catastrophes",
        theme_colonies: "colonies",
        theme_conflits_et_relations_internationales: "conflits et relations internationales",
        theme_economie: "économie",
        theme_education: "éducation",
        theme_justice: "justice",
        theme_medias: "médias",
        theme_politique: "politique",
        theme_religions: "religions",
        theme_sante: "santé",
        theme_sciences: "sciences",
        theme_societe: "société",
        theme_sports_et_loisirs: "sports et loisirs",

        theme_l2_architecture: "Architecture",
        theme_l2_arts_decoratifs: "Arts décoratifs",
        theme_l2_musee: "Musée",
        theme_l2_bibliotheque: "Bibliothèque",
        theme_l2_cabinet_des_estampes: "Cabinet des estampes",
        theme_l2_cinema: "Cinéma",
        theme_l2_collection_doeuvres_dart: "Collection d'œuvres d'art",
        theme_l2_cabinet_de_curiosites: "Cabinet de curiosités",
        theme_l2_coutumes_et_traditions: "Coutumes et traditions",
        theme_l2_culture_religieuse: "Culture religieuse",
        theme_l2_culture_militaire: "Culture militaire",
        theme_l2_culture_populaire: "Culture populaire",
        theme_l2_danse: "Danse",
        theme_l2_exposition_dart: "Exposition d'art",
        theme_l2_foire: "Foire",
        theme_l2_exposition_universelle: "Exposition universelle",
        theme_l2_gastronomie: "Gastronomie",
        theme_l2_litterature: "Littérature",
        theme_l2_marche_de_lart: "Marché de l'art",
        theme_l2_mode: "Mode",
        theme_l2_musique: "Musique",
        theme_l2_patrimoine_naturel: "Patrimoine naturel",
        theme_l2_patrimoine_artistique: "Patrimoine artistique",
        theme_l2_patrimoine_architectural: "Patrimoine architectural",
        theme_l2_peinture: "Peinture",
        theme_l2_photographie: "Photographie",
        theme_l2_radio: "Radio",
        theme_l2_sculpture: "Sculpture",
        theme_l2_theatre: "Théâtre",
        theme_l2_urbanisme: "Urbanisme",
        theme_l2_dessin_anime: "Dessin animé",
        theme_l2_bande_dessinee: "Bande dessinée",
        theme_l2_opera: "Opéra",
        theme_l2_television: "Télévision",
        theme_l2_parfumerie: "Parfumerie",
        theme_l2_accident_aerien: "Accident aérien",
        theme_l2_accident_maritime: "Accident maritime",
        theme_l2_accident_ferroviaire: "Accident ferroviaire",
        theme_l2_accident_routier: "Accident routier",
        theme_l2_accident_industriel: "Accident industriel",
        theme_l2_desastre_meteorologique: "Désastre météorologique",
        theme_l2_epizooties: "Épizooties",
        theme_l2_eruption_volcanique: "Éruption volcanique",
        theme_l2_famine: "Famine",
        theme_l2_incendie: "Incendie",
        theme_l2_inondation: "Inondation",
        theme_l2_pollution: "Pollution",
        theme_l2_secheresse: "Sécheresse",
        theme_l2_tremblement_de_terre: "Tremblement de terre",
        theme_l2_maree_noire: "Marée noire",
        theme_l2_catastrophe_miniere: "Catastrophe minière",
        theme_l2_rupture_de_barrage: "Rupture de barrage",
        theme_l2_explosion_accidentelle: "Explosion accidentelle",
        theme_l2_administration_coloniale: "Administration coloniale",
        theme_l2_colons: "Colons",
        theme_l2_compagnies_coloniales: "Compagnies coloniales",
        theme_l2_conquetes: "Conquêtes",
        theme_l2_economie_coloniale: "Économie coloniale",
        theme_l2_exposition_coloniale: "Exposition coloniale",
        theme_l2_peuples_colonises: "Peuples colonisés",
        theme_l2_presse_coloniale: "Presse coloniale",
        theme_l2_propagande_coloniale: "Propagande coloniale",
        theme_l2_rivalites_coloniales: "Rivalités coloniales",
        theme_l2_expedition_coloniale: "Expédition coloniale",
        theme_l2_armement: "Armement",
        theme_l2_conferences_et_sommets: "Conférences et sommets",
        theme_l2_coup_detat: "Coup d'État",
        theme_l2_economie_de_guerre: "Économie de guerre",
        theme_l2_guerre: "Guerre",
        theme_l2_massacre: "Massacre",
        theme_l2_traites_et_accords: "Traités et accords",
        theme_l2_agriculture: "Agriculture",
        theme_l2_elevage: "Élevage",
        theme_l2_viticulture: "Viticulture",
        theme_l2_finances_publiques: "Finances publiques",
        theme_l2_analyse_financiere: "Analyse financière",
        theme_l2_industrie_chimique: "Industrie chimique",
        theme_l2_commerce: "Commerce",
        theme_l2_distribution: "Distribution",
        theme_l2_energie_nucleaire: "Énergie nucléaire",
        theme_l2_electricite: "Électricité",
        theme_l2_petrole: "Pétrole",
        theme_l2_mineraux: "Minéraux",
        theme_l2_charbon: "Charbon",
        theme_l2_gaz_naturel: "Gaz naturel",
        theme_l2_immobilier: "Immobilier",
        theme_l2_industrie_de_transformation: "Industrie de transformation",
        theme_l2_industries_metallurgiques_et_mecaniques: "Industries métallurgiques et mécaniques",
        theme_l2_macro_economie: "Macro économie",
        theme_l2_marches: "Marchés",
        theme_l2_metaux: "Métaux",
        theme_l2_services_financiers: "Services financiers",
        theme_l2_transport: "Transport",
        theme_l2_vie_des_affaires: "Vie des affaires",
        theme_l2_concours: "Concours",
        theme_l2_etablissement_denseignement_superieur: "Établissement d'enseignement supérieur",
        theme_l2_ecole_secondaire: "École secondaire",
        theme_l2_ecole_professionnelle: "École professionnelle",
        theme_l2_ecole_primaire: "École primaire",
        theme_l2_maternelle: "Maternelle",
        theme_l2_education_des_filles: "Éducation des filles",
        theme_l2_education_religieuse: "Éducation religieuse",
        theme_l2_enseignants: "Enseignants",
        theme_l2_lois_scolaires: "Lois scolaires",
        theme_l2_pedagogie: "Pédagogie",
        theme_l2_universite: "Université",
        theme_l2_parc_naturel: "Parc naturel",
        theme_l2_dechets: "Déchets",
        theme_l2_reserve_naturelle: "Réserve naturelle",
        theme_l2_ecosysteme: "Écosystème",
        theme_l2_espece_menacee: "Espèce menacée",
        theme_l2_meteo: "Météo",
        theme_l2_attentat: "Attentat",
        theme_l2_crime_de_guerre: "Crime de guerre",
        theme_l2_assassinat: "Assassinat",
        theme_l2_evasion: "Évasion",
        theme_l2_piraterie: "Piraterie",
        theme_l2_infraction_sexuelle: "Infraction sexuelle",
        theme_l2_braquage: "Braquage",
        theme_l2_faux_en_art: "Faux en art",
        theme_l2_contrebande: "Contrebande",
        theme_l2_incendie_volontaire: "Incendie volontaire",
        theme_l2_agression: "Agression",
        theme_l2_enlevement: "Enlèvement",
        theme_l2_crime_organise: "Crime organisé",
        theme_l2_terrorisme: "Terrorisme",
        theme_l2_vol: "Vol",
        theme_l2_detournement_davion: "Détournement d'avion",
        theme_l2_prise_dotages: "Prise d'otages",
        theme_l2_faux_monnayage: "Faux-monnayage",
        theme_l2_corruption: "Corruption",
        theme_l2_fraude_fiscale: "Fraude fiscale",
        theme_l2_droits: "Droits",
        theme_l2_lois: "Lois",
        theme_l2_prison: "Prison",
        theme_l2_condamnation_a_perpetuite: "Condamnation à perpétuité",
        theme_l2_torture_et_punition_corporelle: "Torture et punition corporelle",
        theme_l2_police: "Police",
        theme_l2_etablissement_penitentiaire: "Établissement pénitentiaire",
        theme_l2_proces: "Procès",
        theme_l2_scandale: "Scandale",
        theme_l2_systeme_judiciaire: "Système judiciaire",
        theme_l2_journalistes_et_reporters: "Journalistes et reporters",
        theme_l2_liberte_de_la_presse_et_censure: "Liberté de la presse et censure",
        theme_l2_patrons_de_presse: "Patrons de presse",
        theme_l2_presse_ecrite: "Presse écrite",
        theme_l2_propagande: "Propagande",
        theme_l2_agence_de_presse: "Agence de presse",
        theme_l2_aide_internationale: "Aide internationale",
        theme_l2_dette_publique: "Dette publique",
        theme_l2_fiscalite: "Fiscalité",
        theme_l2_impot_religieux: "Impôt religieux",
        theme_l2_communisme: "Communisme",
        theme_l2_constitution: "Constitution",
        theme_l2_renseignement_militaire: "Renseignement militaire",
        theme_l2_armee: "Armée",
        theme_l2_mercenariat: "Mercenariat",
        theme_l2_diplomatie: "Diplomatie",
        theme_l2_droits_de_lhomme: "Droits de l'homme",
        theme_l2_elections: "Élections",
        theme_l2_espionnage: "Espionnage",
        theme_l2_gouvernement: "Gouvernement",
        theme_l2_groupe_de_pression: "Groupe de pression",
        theme_l2_ideologies_et_systemes: "Idéologies et systèmes",
        theme_l2_institutions_locales: "Institutions locales",
        theme_l2_migration: "Migration",
        theme_l2_parlement: "Parlement",
        theme_l2_partis_politiques: "Partis politiques",
        theme_l2_politique_sociale_en_france: "Politique sociale en France",
        theme_l2_politique_culturelle_en_france: "Politique culturelle en France",
        theme_l2_politique_des_transports_en_france: "Politique des transports en France",
        theme_l2_politique_energetique_en_france: "Politique énergétique en France",
        theme_l2_amenagement_du_territoire_en_france: "Aménagement du territoire en France",
        theme_l2_referendum: "Référendum",
        theme_l2_socialisme: "Socialisme",
        theme_l2_organisation_internationale: "Organisation internationale",
        theme_l2_nationalisation: "Nationalisation",
        theme_l2_privatisation: "Privatisation",
        theme_l2_chefs_religieux: "Chefs religieux",
        theme_l2_eglise_institution: "Église - Institution",
        theme_l2_evenement_religieux: "Événement religieux",
        theme_l2_ordres_religieux: "Ordres religieux",
        theme_l2_relations_entre_institutions_religieuses_et_letat: "Relations entre Institutions religieuses et l'État",
        theme_l2_rite: "Rite",
        theme_l2_texte_religieux: "Texte religieux",
        theme_l2_epidemie: "Épidémie",
        theme_l2_examens_medicaux: "Examens médicaux",
        theme_l2_hopitaux_et_cliniques: "Hôpitaux et cliniques",
        theme_l2_hygiene: "Hygiène",
        theme_l2_maladies: "Maladies",
        theme_l2_medicament: "Médicament",
        theme_l2_organisation_de_sante: "Organisation de santé",
        theme_l2_personnel_medical: "Personnel médical",
        theme_l2_politique_de_sante: "Politique de santé",
        theme_l2_traitement_medical: "Traitement médical",
        theme_l2_chirurgie: "Chirurgie",
        theme_l2_vaccin: "Vaccin",
        theme_l2_climatologie: "Climatologie",
        theme_l2_ethnologie: "Ethnologie",
        theme_l2_geographie: "Géographie",
        theme_l2_geologie: "Géologie",
        theme_l2_histoire: "Histoire",
        theme_l2_institutions_scientifiques: "Institutions scientifiques",
        theme_l2_mathematiques: "Mathématiques",
        theme_l2_oceanographie: "Océanographie",
        theme_l2_philosophie_des_sciences: "Philosophie des sciences",
        theme_l2_prix_et_recompenses: "Prix et récompenses",
        theme_l2_societe_savante: "Société savante",
        theme_l2_laboratoire_de_recherche: "Laboratoire de recherche",
        theme_l2_recherche_medicale: "Recherche médicale",
        theme_l2_archeologie: "Archéologie",
        theme_l2_sylviculture: "Sylviculture",
        theme_l2_artisanat: "Artisanat",
        theme_l2_technique_policiere: "Technique policière",
        theme_l2_metallurgie: "Métallurgie",
        theme_l2_pharmacie: "Pharmacie",
        theme_l2_aeronautique: "Aéronautique",
        theme_l2_optique: "Optique",
        theme_l2_astronautique: "Astronautique",
        theme_l2_astronomie: "Astronomie",
        theme_l2_construction: "Construction",
        theme_l2_metrologie: "Métrologie",
        theme_l2_armurerie: "Armurerie",
        theme_l2_medecine: "Médecine",
        theme_l2_technologie_miniere: "Technologie minière",
        theme_l2_technologie_du_transport: "Technologie du transport",
        theme_l2_genie_civil: "Génie civil",
        theme_l2_genie_chimique: "Génie chimique",
        theme_l2_genie_mecanique: "Génie mécanique",
        theme_l2_hydraulique: "Hydraulique",
        theme_l2_agronomie: "Agronomie",
        theme_l2_electronique: "Électronique",
        theme_l2_zoologie: "Zoologie",
        theme_l2_botanique: "Botanique",
        theme_l2_paleontologie: "Paléontologie",
        theme_l2_chimie: "Chimie",
        theme_l2_horticulture: "Horticulture",
        theme_l2_physique: "Physique",
        theme_l2_exploration_scientifique: "Exploration scientifique",
        theme_l2_anthropologie: "Anthropologie",
        theme_l2_linguistique: "Linguistique",
        theme_l2_sociologie: "Sociologie",
        theme_l2_activites_caritatives: "Activités caritatives",
        theme_l2_noblesse: "Noblesse",
        theme_l2_proletariat: "Prolétariat",
        theme_l2_domesticite: "Domesticité",
        theme_l2_bourgeoisie_urbaine: "Bourgeoisie urbaine",
        theme_l2_categories_sociales_et_professionnelles: "Catégories sociales et professionnelles",
        theme_l2_chomage: "Chômage",
        theme_l2_condition_feminine: "Condition féminine",
        theme_l2_duree_du_travail: "Durée du travail",
        theme_l2_syndicalisme: "Syndicalisme",
        theme_l2_travail_des_enfants: "Travail des enfants",
        theme_l2_demographie: "Démographie",
        theme_l2_esclavage: "Esclavage",
        theme_l2_homosexualite: "Homosexualité",
        theme_l2_mariage: "Mariage",
        theme_l2_divorce: "Divorce",
        theme_l2_avortement: "Avortement",
        theme_l2_greve: "Grève",
        theme_l2_lois_sur_le_travail: "Lois sur le travail",
        theme_l2_orphelinat: "Orphelinat",
        theme_l2_pauvrete: "Pauvreté",
        theme_l2_protection_sociale: "Protection sociale",
        theme_l2_racisme_et_xenophobie: "Racisme et Xénophobie",
        theme_l2_salaires: "Salaires",
        theme_l2_delinquance_juvenile: "Délinquance juvénile",
        theme_l2_prostitution: "Prostitution",
        theme_l2_suicide: "Suicide",
        theme_l2_pornographie: "Pornographie",
        theme_l2_troubles_civils: "Troubles civils",
        theme_l2_alpinisme_et_escalade: "Alpinisme et escalade",
        theme_l2_athletisme: "Athlétisme",
        theme_l2_automobile: "Automobile",
        theme_l2_aviron: "Aviron",
        theme_l2_badminton: "Badminton",
        theme_l2_boule_anglaise_et_petanque: "Boule anglaise et pétanque",
        theme_l2_bowling: "Bowling",
        theme_l2_boxe: "Boxe",
        theme_l2_carnavals_et_corteges: "Carnavals et cortèges",
        theme_l2_chasse: "Chasse",
        theme_l2_clubs_et_associations: "Clubs et associations",
        theme_l2_course_de_chiens: "Course de chiens",
        theme_l2_cricket: "Cricket",
        theme_l2_curling: "Curling",
        theme_l2_cyclisme: "Cyclisme",
        theme_l2_equitation: "Équitation",
        theme_l2_escrime: "Escrime",
        theme_l2_evenements_sportifs: "Événements sportifs",
        theme_l2_football: "Football",
        theme_l2_golf: "Golf",
        theme_l2_gymnastique_artistique: "Gymnastique artistique",
        theme_l2_halterophilie: "Haltérophilie",
        theme_l2_hippisme: "Hippisme",
        theme_l2_hockey_sur_gazon: "Hockey sur gazon",
        theme_l2_jeux_de_societe: "Jeux de société",
        theme_l2_echecs: "Échecs",
        theme_l2_jeux_de_cartes: "Jeux de cartes",
        theme_l2_jeux_de_hasard_et_loteries: "Jeux de hasard et loteries",
        theme_l2_jeux_olympiques: "Jeux olympiques",
        theme_l2_judo: "Judo",
        theme_l2_karate: "Karaté",
        theme_l2_lacrosse: "Lacrosse",
        theme_l2_luge: "Luge",
        theme_l2_lutte: "Lutte",
        theme_l2_natation: "Natation",
        theme_l2_patinage_artistique: "Patinage artistique",
        theme_l2_patinage_de_vitesse: "Patinage de vitesse",
        theme_l2_peche: "Pêche",
        theme_l2_pelote_basque: "Pelote basque",
        theme_l2_polo: "Polo",
        theme_l2_rodeo: "Rodéo",
        theme_l2_rugby_a_xv: "Rugby à XV",
        theme_l2_ski: "Ski",
        theme_l2_sports_aeriens_et_daviation: "Sports aériens et d'aviation",
        theme_l2_tennis: "Tennis",
        theme_l2_tennis_de_table: "Tennis de table",
        theme_l2_tir: "Tir",
        theme_l2_tir_a_larc: "Tir à l'arc",
        theme_l2_tourisme: "Tourisme",
        theme_l2_voile: "Voile",
        theme_l2_basket_ball: "Basket-ball",
        theme_l2_tauromachie: "Tauromachie",
        theme_l2_handball: "Handball",
        theme_l2_hockey_sur_glace: "Hockey sur glace",
        theme_l2_marathon: "Marathon",
        theme_l2_moto: "Moto",
        theme_l2_sumo: "Sumo",
        theme_l2_volley_ball: "Volley-ball",
        theme_l2_water_polo: "Water-polo",
        theme_l2_catch: "Catch",

        theme_l2_bibliotheque_et_musee: "Bibliothèque et musée",
        theme_l2_arts_radio: "Radio",
        theme_l2_patrimoine: "Patrimoine",
        theme_l2_divertissement: "Divertissement",
        theme_l2_culture: "Culture",
        theme_l2_expositions_et_salons: "Expositions et salons",
        theme_l2_collections: "Collections",
        theme_l2_marches_de_l_art: "Marché de l'art",
        theme_l2_expositions_universelles: "Expositions universelles",
        theme_l2_criminalite: "Criminalité",
        theme_l2_peines: "Peines",
        theme_l2_accusation: "Accusation",
        theme_l2_delinquance_financiere: "Délinquance financière",
        theme_l2_crimes_de_guerre: "Crime de guerre",
        theme_l2_attentats: "Attentat",
        theme_l2_scandales: "Scandale",
        theme_l2_faits_divers: "Fait divers",
        theme_l2_accidents_industriels: "Accident industriel",
        theme_l2_desastres_meteorologiques: "Désastre météorologique",
        theme_l2_accident_de_transport: "Accident de transport",
        theme_l2_equipement_et_immobilier: "Equipement et immobilier",
        theme_l2_energie_et_ressources: "Energie et ressources",
        theme_l2_metaux_et_mineraux: "Métaux et minéraux",
        theme_l2_industries_de_transformation: "Industries de transformation",
        theme_l2_commerce_international: "Commerce",
        theme_l2_banques_et_finances: "Banques et Finances",
        theme_l2_enfance: "Enfance",
        theme_l2_ecole: "Ecoles",
        theme_l2_epidemies: "Epidémies",
        theme_l2_traitements: "Traitements",
        theme_l2_organisations_de_sante: "Organisations de santé",
        theme_l2_medicaments: "Médicaments",
        theme_l2_blessures: "Blessures",
        theme_l2_specialisation_medicale: "Spécialisations médicales",
        theme_l2_defense: "Défense",
        theme_l2_droits_de_l_homme: "Droits de l'homme",
        theme_l2_budget_de_l_etat_et_impots: "Budget de l'Etat et impôts",
        theme_l2_traites_et_organisations_internationales: "Traités et organisations internationales",
        theme_l2_politique_interieure: "Politique Intérieure",
        theme_l2_migrations: "Migrations",
        theme_l2_medias_radio: "Radio",
        theme_l2_croyance: "Croyances (cultes et sectes > Christianisme, Judaïsme)",
        theme_l2_eglise: "Eglise",
        theme_l2_relations_entre_institutions_religieuses_et_l_etat: "Relations entre Institutions religieuses et l'Etat (Concordat)",
        theme_l2_textes_religieux: "Textes religieux",
        theme_l2_evenements_religieux: "Evénement religieux",
        theme_l2_sciences_et_religions: "Sciences et religions",
        theme_l2_rites: "Rites",
        theme_l2_sciences_appliquees: "Sciences appliquées",
        theme_l2_recherche: "Recherche",
        theme_l2_technologie_et_ingenierie: "Technologie et Ingénierie",
        theme_l2_instituts_scientifiques: "Institutions scientifiques",
        theme_l2_activites_caricatives: "Activités caritatives",
        theme_l2_famille: "Famille",
        theme_l2_problemes_de_societe: "Problèmes de société",
        theme_l2_greves: "Grève",
        theme_l2_conditions_feminines: "Condition féminine",
        theme_l2_syndicats: "Syndicats",
        theme_l2_orphelinats: "Orphelinats",
        theme_l2_ascension_sociale_carriere: "Carrière/Ascension sociale",
        theme_l2_conditions_de_travail: "Conditions de travail",
        theme_l2_sports_aeriens_et_d_aviation: "Sports aériens et d'aviation",
        theme_l2_tir_a_l_arc: "Tir à l'arc",
        theme_l2_ski_acrobatique: "Ski acrobatique",
        theme_l2_rugby: "Rugby à XV",
        theme_l2_organisations_sportives: "Organisations sportives",
        theme_l2_desordres_civils: "Désordres civils",
        theme_l2_coup_d_etat: "Coup d'état",
        theme_l2_traites_et_accords_de_guerre: "Traités et acccords",
        theme_l2_sommets_et_conferences: "Conférences et sommets",
        theme_l2_enjeux_territoriaux: "Enjeux territoriaux",
        theme_l2_expositions_coloniales: "Expositions coloniales",
        theme_l2_colonialisme: "Colonialisme",       

        document_not_found: "document not found",
        save_in_progress: "Sauvegarde en cours",
        unable_to_save: "Impossible de sauver pour le moment",
        save_ok: "Sauvegarde réussie",
        something_wrong: "something goes wrong...",
        wrong_syntax_pages: "Veuillez vérifier la syntaxe des pages sélectionnées",
        no_result: "No result found",
        search_in_progress: "Search in progress...",
        facebook_message: "Explorer, trouver, comprendre",
        confirm_delete_annotation: "Are you sure you want to delete this annotation?",
        text_is_missing: "Text, search and entities are not available for this document",
        copy_url_ok: "Vous pouvez coller l'URL pour accéder directement à cette page avec la zone surligée dans le lecteur",
        search_results: "search results",
        no_other_result: "No more result",
        time_ago: {
            prefix: "",
            suffix: " ago",
            seconds: "less than a minute",
            minute: "about a minute",
            minutes: "%d minutes",
            hour: "about an hour",
            hours: "about %d hours",
            day: "a day",
            days: "%d days",
            month: "about a month",
            months: "%d months",
            year: "about a year",
            years: "%d years"
        },
        comment_mini: "Veuillez saisir au minimum 20 caractères",
        no_main_articles: "Aucun article n'a été détecté dans cette page.",
        embed_activated:"Lecteur activé",
        date: function(date,day_name) {
            if (!date) return;
            var date_array = date.split("-"),
                date_en;
            if (date_array.length == 3) {
                date_en = date_array[2] + " " + STR["month_" + parseInt(date_array[1])] + " " + date_array[0];
                if(day_name){
                    var date_obj=new Date(Date.UTC(parseInt(date_array[0]),parseInt(date_array[1])-1,parseInt(date_array[2])));
                    date_en=STR["day_" +date_obj.getUTCDay()]+" "+date_en;
                }
            }
            return date_en;
        },
        number: function(n) {
            if (!n) return;
            return Number(n).toLocaleString(STR.locale, {
                useGrouping: true
            });
        },
        documentTitle:function(doc_title){
            if(!doc_title)return;
            var reg = new RegExp("^[0-9]+$");
            if (reg.test(doc_title)) {
                doc_title = "N°" + doc_title;
            }
            return doc_title;
        }
    }
};